import { CSRF_COOKIE_NAME } from '@wingseat/shared';

const CSRF_PATH = '/api/auth/csrf';

function readCookie(name: string): string | null {
  if (typeof document === 'undefined') return null;
  const match = document.cookie.match(
    new RegExp(
      '(?:^|; )' + name.replace(/[.$?*|{}()[\]\\+^]/g, '\\$&') + '=([^;]*)',
    ),
  );
  return match ? decodeURIComponent(match[1] ?? '') : null;
}

let initPromise: Promise<void> | null = null;
let initializedOnce = false;
let cachedToken: string | null = null;

/**
 * Stellt sicher, dass ein frisches CSRF-Cookie und Token für die aktuelle
 * Session vorhanden sind. `csrf-csrf` speichert intern `randomToken|hash`
 * im Cookie, erwartet im Header aber **nur** `randomToken` — daher nutzen
 * wir den `token`-Wert aus dem JSON-Response, nicht `document.cookie`.
 */
export function ensureCsrfInitialized(opts: { force?: boolean } = {}): Promise<void> {
  if (
    initializedOnce &&
    !opts.force &&
    cachedToken &&
    readCookie(CSRF_COOKIE_NAME)
  ) {
    return Promise.resolve();
  }
  if (initPromise) return initPromise;
  initPromise = (async () => {
    try {
      const res = await fetch(CSRF_PATH, {
        credentials: 'include',
        headers: { Accept: 'application/json' },
        cache: 'no-store',
      });
      if (!res.ok) throw new Error(`CSRF init: HTTP ${res.status}`);
      const body = (await res.json().catch(() => null)) as {
        token?: string;
      } | null;
      if (body?.token) cachedToken = body.token;
      initializedOnce = true;
    } catch (err) {
      console.warn('CSRF-Init fehlgeschlagen', err);
      throw err;
    } finally {
      initPromise = null;
    }
  })();
  return initPromise;
}

/** Liefert den zuletzt vom Server bekommenen CSRF-Token (oder null). */
export function getCsrfToken(): string | null {
  return cachedToken;
}
